import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  engravingYourText: {
    id: 'engraving.enter.your.text',
    defaultMessage: 'Zadejte Váš text',
  },
  engravingInvalidCharacters: {
    id: 'engraving.invalid.characters',
    defaultMessage: 'Je možné použít pouze znaky [a-ž, A-Ž, 0-9]',
  },
  engravingSave: {
    id: 'engraving.save',
    defaultMessage: 'OK',
  },
  addEngraving: {
    id: 'engraving.add',
    defaultMessage: 'Přidat gravírování',
  },
  engravingPreview: {
    id: 'engraving.preview',
    defaultMessage: 'Foto produktu s gravírovaným textem je pouze ilustrační.',
  },
  engravingCheckboxLabel: {
    id: 'engraving.checkbox.label',
    defaultMessage: 'Vygravírovat vlastní text za {price}',
  },
  engravingCheckboxCheckedLabel: {
    id: 'engraving.checkbox.checked.label',
    defaultMessage: 'Přidáno gravírování s textem "{initials}"',
  },
  engravingCheckboxLabelDesc: {
    id: 'engraving.checkbox.label.description.with.link',
    defaultMessage:
      'Nechte si na produkt laserem vyrýt vlastní text a vytvořte tak dárek od srdce. Dali jsme pro vás dohromady <a>tipy</a> na ta nejhezčí věnování.',
  },
  engravingSpecialPageHref: {
    id: 'engraving.special.page.href',
    defaultMessage: 'https://www.notino.cz/gravirovani/',
  },
  engravingEdit: {
    id: 'engraving.edit',
    defaultMessage: 'upravit',
  },
  drawerTitle: {
    id: 'engraving.drawer.title',
    defaultMessage: 'Gravírování vlastního textu',
  },
  addedNotificationText: {
    id: 'engraving.notification.engravingAdded',
    defaultMessage: 'Gravírování bylo úspěšně přidáno.',
  },
  removedNotificationText: {
    id: 'engraving.notification.engravingRemoved',
    defaultMessage: 'Gravírování bylo odebráno.',
  },
});
